import { svgList, dataArr, baseImg } from "./base";

const data = {
  stat: 1,
  msg: "",
  data: {
    banner: {
      poster:
        "https://editor.xesimg.com/tailor/resource/science-1653048117859.jpg",
      videoUrl:
        "https://editor.xesimg.com/tailor/resource/kexue-1650703499398.mp4",
      // completeVideoUrl:
      //   "https://static0.xesimg.com/platform-fe/mallwww/video/science1.mp4",
      // completeHightVideoUrl:
      //   "https://static0.xesimg.com/platform-fe/mallwww/video/science2.mp4",
      slogan:
        "https://editor.xesimg.com/tailor/resource/kexue-1689413523495.svg"
    },
    pageData: {
      type: "science",
      whyLearning: {
        type: "science",
        title: "为什么要让孩子学科学？",
        decs:
          '学而思素养科学，以"培养活思维，脑力更充沛"为理念，通过生动有趣的实验和探究式的开放课堂，培养孩子：',
        cardList: [
          {
            img:
              "https://editor.xesimg.com/tailor/resource/whyLearningScience1-1650943288722.png",
            title: "建立跨领域知识系统",
            imgAlt: "建立跨领域知识系统",
            desc:
              "课程覆盖生命科学、物质科学、地球宇宙、工程技术、人文社会五大内容模块，帮助孩子构建跨领域知识体系，满足解决综合性问题的需要。"
          },
          {
            img:
              "https://editor.xesimg.com/tailor/resource/whyLearningScience2-1650943288722.png",
            title: "培养科学",
            imgAlt: "培养科学",
            desc:
              "通过“抽象思维”“逻辑思维”和“创造思维”的培养，帮助孩子养成基于事实和逻辑做出正确判断的思考方式，让孩子遇事更冷静，避免情绪化。"
          },
          {
            img:
              "https://editor.xesimg.com/tailor/resource/whyLearningScience3-1650943288723.png",
            title: "掌握探究和解决问题的方法",
            imgAlt: "掌握探究和解决问题的方法",
            desc:
              "通过“探究式”“项目式”的教学方式，引导孩子学习科学探究的方法，让孩子在实践中学习如何调用自我知识体系，找到解决方案。"
          }
        ]
      },
      core: {
        title: "学而思素养科学培养哪些核心素养？",
        decs:
          "以“中国学生发展核心素养“为依托，培养孩子“理性思维”、“问题解决”和“勇于探究”三大核心素养。",
        content: {
          echart: {
            defaultIndex: 3,
            baseImg,
            svgList,
            dataArr
          },
          coreList: [
            {
              title: "理性思维",
              content: `通过抽象培养4式（看现象、做对比、巧分类、建模型）培养抽象思维，带领孩子观察关于万物的现象，培养孩子提炼特征、寻找规律，分类建模描述核心假设和结论的能力。<br/><br/>
              通过逻辑培养5步（拆问题、找重点、归原因、做实验、会分析）培养逻辑思维，锻炼孩子"分解"、"推理"和"分析"三大核心能力，教孩子如何找到复杂问题背后的原因，主动思考，逐步构建自我知识体系。`,
              active: 3
            },
            {
              title: "勇于探究",
              content:
                "采用6步教学法（观察现象、提出问题、设计&实验、交流观点、联系应用、自主实践），通过探究式课堂不断启发孩子动手实践，深入思考。",
              active: 5
            },
            {
              title: "问题解决",
              content:
                "创造培养6招（广联想、巧迁移、逆思考、勤调查、妙设计、善迭代），通过课上案例解析和课下项目制练习，锻炼孩子跨领域知识应用和解决新问题的能力。",
              active: 16
            }
          ]
        }
      },
      educateSystem: {
        title: "学而思素养科学的培养体系",
        imgSrc:
          "https://editor.xesimg.com/tailor/resource/scienceSys-1650766492964.svg"
      },
      advantage: {
        title: "学而思素养科学有什么优势？",
        tabs: [
          {
            title: "独创6步教学法",
            cardList: [
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/card1-1651138247263.png",
                title: "观察现象",
                imgAlt: "观察现象",
                content: "从身边有趣现象入手，培养兴趣、观察力、专注力"
              },
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/card2-1651137919750.png",
                title: "提出问题",
                imgAlt: "提出问题",
                content: "鼓励孩子提出问题，启发孩子用不同视角看问题"
              },
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/card3-1651137919751.png",
                title: "设计并实验",
                imgAlt: "设计并实验",
                content: "提出假设，分析框架，设计实验，动手执行"
              },
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/card4-1651137919752.png",
                title: "交流观点",
                imgAlt: "交流观点",
                content: "小组内交流，培养自信表达，接受多元思想"
              },
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/card5-1651137919753.png",
                title: "联系实践应用",
                imgAlt: "联系实践应用",
                content: "从现象、原理联系日常生活其它场景，培养创新力"
              },
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/card6-1651137919753.png",
                title: "自主项目实践",
                imgAlt: "自主项目实践",
                content: "课下自主实践，完成科学项目，鼓励孩子合作与创造"
              }
            ]
          },
          {
            title: "多样的课堂体验",
            cardList: [
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/combine1-1650943833257.png",
                imgAlt: "探究式课堂启发思考",
                title: "探究式课堂启发思考",
                desc:
                  "每节课都以一个问题的形式引导孩子自主探究，在实践中建立现象、原理和实际生活的关联。"
              },
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/combine2-1650943833257.png",
                title: "多样化互动赋予成就",
                imgAlt: "多样化互动赋予成就",
                desc:
                  "科学圆桌、一起实验环节，以小组讨论的方式让孩子课上动口动手，在交流和表达中建立自信。"
              },
              {
                imgSrc:
                  "https://editor.xesimg.com/tailor/resource/combine3-1650943833257.png",
                title: "开放式教具激发创造",
                imgAlt: "开放式教具激发创造",
                desc:
                  "自主研发的多种开放式教具，让孩子有动手的乐趣，鼓励孩子在动手实践中不断创新创造。"
              }
            ]
          },
          {
            title: "博闻多识的师资团队",
            card: {
              title:
                "科学的师资团队，每一位老师都是科学的爱好者，深谙科学的授业之道，懂得如何用有趣的问题引发孩子的好奇心，以及如何将知识深入浅出的传授给孩子。",
              imgAlt: "师资团队",
              imgSrc:
                "https://editor.xesimg.com/tailor/resource/team2-1651207688704.png"
            }
          }
        ]
      },
      // classroom: {
      //   title: "学而思素养科学的课堂",
      //   // subTitle: "精彩课堂",
      //   // video: {
      //   //   poster:
      //   //     "https://editor.xesimg.com/tailor/resource/sciencePoster1-1650956090198.jpg",
      //   //   src:
      //   //     "https://editor.xesimg.com/tailor/resource/Classroom1-1661753545345.mp4"
      //   // },
      //   showCardList: true,
      //   thirdTitle: "探究达人",
      //   VideoCardList: [
      //     {
      //       poster:
      //         "https://editor.xesimg.com/tailor/resource/sciencePoster2-1650956090199.jpg",
      //       src:
      //         "https://editor.xesimg.com/tailor/resource/explore1-1650703337960.mp4"
      //     },
      //     {
      //       poster:
      //         "https://editor.xesimg.com/tailor/resource/sciencePoster3-1650956090199.jpg",
      //       src:
      //         "https://editor.xesimg.com/tailor/resource/explore2-1650703337960.mp4"
      //     }
      //   ]
      // },
      footer: {
        img:
          "https://editor.xesimg.com/tailor/resource/kexue-1650693904009.png",
        title: "生活中的科学实验课",
        imgAlt: "科学",
        titleTag: "3节直播课",
        qrCodeUrl:
          "https://editor.xesimg.com/tailor/resource/science-qr-1666948081468.png",
        subTitle:
          "3个动手实验&nbsp;&nbsp;&nbsp;&nbsp;8次思维大挑战&nbsp;&nbsp;&nbsp;&nbsp;12次头脑风暴讨论"
      }
    }
  }
};
export default data;
